import React from 'react';
import './index.css';
import { useLocation } from 'react-router-dom';

const Navbar = () => {
    const location = useLocation();

    const formatter = (text) => {
        let string = text.slice(1,text.length);
        return string.replace('/', '-');
    }
    return(
        <div className='navbar-main'>
            <p className='boiler mb-0'>{formatter(location?.pathname)}</p>
            {/* <div>
            <div class="dropdown">
                <button class=" bg-transparent border-0 dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Admin
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                    <a class="dropdown-item" href="#">Action</a>
                    <a class="dropdown-item" href="#">Another action</a>
                    <a class="dropdown-item" href="#">Something else here</a>
                </div>
            </div>
            </div> */}
        </div>
    );
}

export default Navbar;
